<template>
  <!-- Inspiration: Code de Jean-François Lavigne (Sidlee) -->
  <!-- https://codepen.io/jflavigne/pen/MWpKpPG -->

  <div>
    <Carte :content="jel_isCarteLarge(content) ? contentCarte : content">
      <div
        :class="(jel_getClassObject(content), `carte-format-${contentCarte.formatCarte}`)"
        class="cursor-pointer d-flex h-100 flex-column carte-wrapper"
      >
        <div class="image-carte">
          <slot name="image"></slot>
        </div>
        <div v-if="afficherInfoSecondaire" class="info-secondaire">
          <slot name="infoSecondaire"></slot>
        </div>
        <div ref="texteCarte" class="card-cover">
          <slot name="infoPrimaire"></slot>
        </div>
      </div>

      <!-- <CarteMenuContextuel
        v-if="content.liensMenu"
        :content="content"
        class="card-menu-contextuel"
      ></CarteMenuContextuel> -->
    </Carte>
  </div>
</template>

<script>
import Carte from '@/components/base/carte/Carte';
import CarteMenuContextuel from '@/components/base/carte/CarteMenuContextuel';

export default {
  name: 'CarteImageInfo',
  components: {
    Carte,
    // CarteMenuContextuel,
  },
  props: {
    content: { type: Object, required: true },
    afficherInfoSecondaire: { type: Boolean, default: false },
  },
  data() {
    return {
      hauteurTexte: 0,
    };
  },
  computed: {
    contentCarte() {
      return {
        ...this.content,
        formatCarte:
          this.jel_isCarteLarge(this.content) && !this.content.isCollectionCasino
            ? '4x3'
            : this.content.formatCarte,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.image-carte {
  height: 0px;
  flex-grow: 1;
  overflow: hidden;
}

.info-secondaire {
  width: 100%;
}

a:hover {
  text-decoration: none;
}

.card-section {
  height: 70%;
  position: relative;
}

.card-header {
  padding: 16px 16px;
  width: 196px;
}

.card-cover {
  display: flex;
  flex-direction: column-reverse;
}

.card-cover__section {
  display: flex;
  flex-direction: row;
  background: $couleur-primaire-bouton-theme-clair;
  color: #fff;
  padding: 15px 16px;
  justify-content: space-between;
}

.card-menu-contextuel {
  position: absolute;
  top: 0;
  right: 0;
}

.carte-format-5x6,
.carte-format-4x3,
.carte-format-5x3 {
  .info-secondaire {
    height: 16%;
  }
  .card-cover {
    height: 30%;
  }
}

.carte-format-5x7 {
  .info-secondaire {
    height: 13.7%;
  }
  .card-cover {
    height: 25.7%;
  }
}
// ios 14.1 a 14.5 (fix aussi pour ios 13)
@supports (-webkit-touch-callout: none) and (not (translate: none)) {
  .format-4x3,
  .card-body,
  .carte-wrapper {
    display: flex !important;
    flex: 1;
    height: 20vh !important;
    min-height: 100%;
    flex-direction: column !important;
    justify-content: space-around;
  }
  .carte-format-4x3 {
    .image-carte {
      height: 58%;
      min-height: 11vh;
    }
    .info-secondaire {
      height: 16%;
      min-height: 4.1vh;
    }
    .card-cover {
      height: 30%;
      min-height: 7.8vh;
    }
  }

  .format-5x7,
  .card-body,
  .carte-wrapper {
    display: flex !important;
    flex: 1;
    height: 30vh !important;
    min-height: 100%;
    flex-direction: column !important;
    justify-content: space-around;
  }
  .carte-format-5x3 {
    .image-carte {
      height: 60%;
      min-height: 13.25vh;
    }
    .info-secondaire {
      height: 14%;
      min-height: 6vh;
    }
    .card-cover {
      height: 26%;
      min-height: 10.6vh;
    }
  }

  .carte-format-5x7 {
    .image-carte {
      height: 58%;
      min-height: 12.25vh;
    }
    .info-secondaire {
      height: 14%;
      min-height: 4vh;
    }
    .card-cover {
      height: 26%;
      min-height: 8.6vh;
    }
  }
  .format-5x6,
  .card-body,
  .carte-wrapper {
    display: flex !important;
    flex: 1;
    height: 23vh !important;
    min-height: 100%;
    flex-direction: column !important;
    justify-content: space-around;
  }
  .carte-format-5x6 {
    .image-carte {
      height: 59%;
      min-height: 11.5vh;
    }
    .info-secondaire {
      height: 16%;
      min-height: 4.1vh;
    }
    .card-cover {
      height: 27%;
      min-height: 7.2vh;
    }
  }
}
//MAC os Catalina Safari v13.1
@media not all and (min-resolution: 0.001dpcm) {
  @supports not (-webkit-touch-callout: none) {
    .carte-wrapper {
      display: flex !important;
      flex: 1;
      height: 50vh !important;
      min-height: 100%;
      flex-direction: column !important;
      justify-content: space-around;
    }
    .carte-format-5x6,
    .carte-format-5x3 {
      .image-carte {
        height: 59%;
        min-height: 30vh;
      }
      .info-secondaire {
        height: 16%;
        min-height: 8vh;
        margin-top: -8vh;
      }
      .card-cover {
        height: 27%;
        min-height: 13.5vh;
      }
    }
    .carte-format-4x3 {
      .image-carte {
        height: 58%;
        min-height: 31.25vh;
      }
      .info-secondaire {
        height: 16%;
        min-height: 8.75vh;
        margin-top: -8.75vh;
      }
      .card-cover {
        height: 30%;
        min-height: 16vh;
      }
    }

    .carte-format-5x7 {
      .image-carte {
        height: 60%;
        min-height: 30vh;
      }
      .info-secondaire {
        height: 14%;
        min-height: 7vh;
        margin-top: -7vh;
      }
      .card-cover {
        height: 26%;
        min-height: 13vh;
      }
    }
  }
}
</style>
